module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_CyrilPerducat_Still.21d1028.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_CyrilPerducat_Still.jpg
// module id = rNuo
// module chunks = 0